module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    staticStyle: {
      "width": "100%",
      "height": "70px",
      "font-size": "18px",
      "padding": "20px"
    },
    attrs: {
      "readonly": "",
      "clickable": "",
      "size": "large",
      "label": "请选择单位",
      "value": _vm.value,
      "placeholder": "选择单位",
      "required": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "value-key": "deptName",
      "columns": _vm.columns
    },
    on: {
      "cancel": function($event) {
        _vm.showPicker = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    staticStyle: {
      "width": "100%",
      "height": "70px",
      "font-size": "18px",
      "padding": "20px"
    },
    attrs: {
      "required": "",
      "size": "large",
      "label": "姓名",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('van-field', {
    staticStyle: {
      "width": "100%",
      "height": "70px",
      "font-size": "18px",
      "padding": "20px"
    },
    attrs: {
      "name": "tel",
      "required": "",
      "size": "large",
      "label": "电话",
      "placeholder": "请输入电话"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "tijiao",
    attrs: {
      "round": "",
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.subConfirm
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41af29e5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tupload.vue
// module id = 534
// module chunks = 1